import en from 'locale/en';
import ko from 'locale/ko';
import zh from 'locale/zh';

export default {
  en,
  ko,
  zh
};
